import { render } from "./purchaseHistoryList.vue?vue&type=template&id=783c4592"
import script from "./purchaseHistoryList.vue?vue&type=script&lang=js"
export * from "./purchaseHistoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__